import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { pagePath, countries } from "../data";

export default function DestinationCard({ page, lang, large = false }) {
  const to = pagePath(lang, page);
  const country = countries[page.country];
  return (
    <Link
      to={to}
      data-testid={`card-${page.id}`}
      className={`group relative block overflow-hidden rounded-2xl border border-border bg-white transition-shadow duration-300 hover:shadow-xl ${
        large ? "md:col-span-2 md:row-span-2" : ""
      }`}
    >
      <div className={`overflow-hidden ${large ? "aspect-[4/3] md:aspect-auto md:h-full md:min-h-[320px]" : "aspect-[4/3]"}`}>
        <img
          src={page.image}
          alt={page.imageAlt[lang]}
          loading="lazy"
          width="1200"
          height="900"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      </div>
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent p-5 pt-16">
        <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-widest text-white/70">
          <MapPin className="h-3 w-3" aria-hidden="true" />
          {page.type === "airport" ? (lang === "it" ? "Aeroporto" : "Airport") : country.name[lang]}
        </p>
        <div className="mt-1 flex items-center justify-between gap-3">
          <h3 className={`font-display font-bold tracking-tight text-white ${large ? "text-2xl md:text-3xl" : "text-xl"}`}>
            {page.name[lang]}
          </h3>
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/15 backdrop-blur transition-colors duration-300 group-hover:bg-ember">
            <ArrowUpRight className="h-4 w-4 text-white" aria-hidden="true" />
          </span>
        </div>
      </div>
    </Link>
  );
}
